import { render, staticRenderFns } from "./MrList.vue?vue&type=template&id=1e499ea4&"
import script from "./MrList.vue?vue&type=script&lang=js&"
export * from "./MrList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports